export default __webpack_public_path__ + "static/media/Order-History.2a6c8050.svg";